import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
// import TermsAndConditionsModal from "./TermsAndConditionsModal";
import Swal from "sweetalert2";
import {
  addBillerTAndC,
  getBillerTAndCByType,
  updateBillerTAndC,
} from "../purchaseManagment/termsAndConditionsApi";
import { routePath } from "../../constants/routePath";
import { useNavigate } from "react-router";

// import {
//   getBillerTAndCByType,
//   addBillerTAndC,
//   updateBillerTAndC,
// } from "./termsAndConditionsApi";

const ReportsTab = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedUIType, setSelectedUIType] = useState("");
  const [selectedAPIType, setSelectedAPIType] = useState("");
  const [tAndCData, setTAndCData] = useState({});
  const navigate = useNavigate();

  const tabs = [
    {
      label: "Recharge Validity Date",
      value: "TCPurchaseOrder",
      apiValue: "Purchase",
      routePath: routePath.RECHARGEREPORT,
    },
  ];

  const openModal = async (tab) => {
    navigate(tab.routePath);

    // setSelectedTab(tab.value);
    // setSelectedUIType(tab.label);
    // setSelectedAPIType(tab.apiValue);
    // setModalOpen(true);

    // try {
    //   const res = await getBillerTAndCByType(tab.apiValue);
    //   if (res?.data?.succeeded) {
    //     setTAndCData((prev) => ({
    //       ...prev,
    //       [tab.value]: res.data.data,
    //     }));
    //   }
    // } catch (err) {
    //   console.error("Fetch T&C error:", err);
    // }
  };

  // const handleSave = async (details) => {
  //   const existing = tAndCData[selectedTab];
  //   const type = selectedAPIType;

  //   try {
  //     if (existing?.id) {
  //       await updateBillerTAndC({ ...existing, details });
  //       Swal.fire({
  //         toast: "true",
  //         position: "top-end",
  //         icon: "success",
  //         text: "Terms and conditions updated successfully",
  //         timer: 3000,
  //         showConfirmButton: false,
  //       });
  //     } else {
  //       await addBillerTAndC({ Type: type, details });
  //       Swal.fire({
  //         toast: "true",
  //         position: "top-end",
  //         icon: "success",
  //         text: "Terms and conditions added successfully",
  //         timer: 3000,
  //         showConfirmButton: false,
  //       });
  //     }

  //     const res = await getBillerTAndCByType(type);
  //     if (res?.data?.succeeded) {
  //       setTAndCData((prev) => ({
  //         ...prev,
  //         [selectedTab]: res.data.data,
  //       }));
  //     }

  //     setModalOpen(false);
  //   } catch (err) {
  //     console.error("Save failed:", err);
  //   }
  // };

  return (
    <Box sx={{ background: "#ede9ff", minHeight: "100vh", p: 3 }}>
      <Grid
        item
        xs={12}
        sx={{
          background:
            "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
          padding: "10px",
          borderRadius: "5px",
          color: "#01008B",
          textAlign: "left",
          marginBottom: "20px",
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: "13px", sm: "14px", md: "15px" },
          }}
        >
          Reports
        </Typography>
      </Grid>
      <Grid container spacing={2} justifyContent="center" sx={{ mb: 3 }}>
        {tabs.map((tab, index) => (
          <Grid item xs={12} sm={5} key={index}>
            <Box
              sx={{
                height: 50,
                backgroundColor: "#01008B",
                borderRadius: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: 1,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                fontWeight: 600,
                color: "#fff",
                cursor: "pointer",
                fontFamily: "'Montserrat', sans-serif",
              }}
              onClick={() => openModal(tab)}
            >
              {tab.label}
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* <TermsAndConditionsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        type={selectedUIType}
        data={tAndCData[selectedTab]}
        onSave={handleSave}
      /> */}
    </Box>
  );
};

export default ReportsTab;
